export const AppEventEnum = Object.freeze({
    test: "test",
    onEditHome: "onEditHome",
    changeMode: "changeMode",
    directFromHere: "directFromHere",
    directToHere: "directToHere",
    addDestination: "addDestination",
    changeSearchInput: "changeSearchInput"
})
